<template>
  <v-container class="max-width-container">
    <v-card-actions>
      <v-btn icon @click="goBack">
        <v-icon>mdi-arrow-left</v-icon>
      </v-btn>
      <v-card-title class="text-h5">My Purchase</v-card-title>
    </v-card-actions>

    <div class="grid">
      <v-card width="140px" height="140px">
        <v-img width="140px" height="140px" :src="order.itemImage"></v-img>
      </v-card>
      <p>R{{ order.price }}</p>
    </div>

    <v-card-text>
      <v-col cols="12">
        <v-card-title class="ml-n7 font-weight-light">
          <h4>Seller</h4>
        </v-card-title>
        <v-row class="py-5">
          <v-avatar size="60px">
            <v-img :src="order.sellerAvatar"></v-img>
          </v-avatar>
          <p class="text-h6 ml-4">{{ order.sellerName }}</p>
        </v-row>

        <v-row>
          <v-btn block>
            <v-icon>mdi-email-outline</v-icon>
          </v-btn>
          <v-divider></v-divider>
        </v-row>
        <v-card-title class="ml-n7 font-weight-light">
          <h4>Info</h4>
        </v-card-title>

        <v-row class="d-flex justify-space-between text-caption">
          <div class="no-line-spacing font-weight-bold">
            <p>State</p>
            <p>Order Id:</p>
            <p>Price:</p>
            <p>Date of Purchase:</p>
          </div>
          <div class="no-line-spacing">
            <p>{{ order.cf_status }}</p>
            <p>{{ order.id }}</p>
            <p>R{{ order.price }}</p>
            <p>{{ order.createdAt }}</p>
          </div>
        </v-row>

        <v-row class="mt-8 mb-2">
          <v-divider></v-divider>
        </v-row>

        <v-card-title class="ml-n7">
          <h4 class="font-weight-light">Delivery</h4>
        </v-card-title>

        <v-row class="d-flex justify-space-between text-caption">
          <div class="no-line-spacing font-weight-medium">
            <p>Delivery Method:</p>
            <p>Phone Number:</p>
            <p>Email:</p>
          </div>
          <div class="no-line-spacing">
            <p>{{ order.trackingNumber }}</p>
            <p>{{ order.deliveryMethod }}</p>
            <p>{{ order.phoneNumber }}</p>
            <p>{{ order.email }}</p>
          </div>
        </v-row>
      </v-col>
    </v-card-text>
  </v-container>
</template>

<script>
import { doc, getDoc, getFirestore } from "firebase/firestore";

export default {
  computed: {
    order() {
      return this.$store.getters["orders/getOrder"];
    },
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    },
    async fetchOrder(orderId) {
      const order = this.$store.getters["orders/getOrder"];

      // if (order && order.id === orderId) {
      //   // Order already exists in the store, no need to fetch it again
      //   return;
      // }

      try {
        console.log(orderId);

        const db = getFirestore();

        const docRef = doc(db, "sales_payments", "yipee");
        const docSnap = await getDoc(docRef);

        if (docSnap.exists()) {
          console.log("Document data:", docSnap.data());
          const order = docSnap.data();
          //convert timestamp to date
          order.createdAt = order.createdAt.toDate().toLocaleDateString();

          //get seller details from order.sellerId and add to order object
          const sellerDocRef = doc(db, "users", order.sellerId);
          const sellerDocSnap = await getDoc(sellerDocRef);
          if (sellerDocSnap.exists()) {
            console.log("Document data:", sellerDocSnap.data());
            const seller = sellerDocSnap.data();
            order.sellerName = seller.firstName;
            order.sellerAvatar = seller.avatar;
            seller.verified = seller.verified;

            console.log("SELLER: ", seller);
          } else {
            // docSnap.data() will be undefined in this case
            console.log("No such document!");
          }

          this.$store.commit("orders/setOrder", order);
        } else {
          // docSnap.data() will be undefined in this case
          console.log("No such document!");
        }
      } catch (error) {
        console.log("Error getting document:", error);
        // Handle error
      }
    },
  },
  created() {
    const orderId = this.$route.params.id;
    console.log(orderId);
    this.fetchOrder(orderId);
  },
};
</script>

<style>
.max-width-container {
  max-width: 1000px;
  margin-left: auto;
  margin-right: auto;
}
.no-line-spacing p {
  margin: 0;
  padding: 0;
}
</style>
